import { useEffect, useState } from 'react';
import { AppDispatch } from 'redux/store';
import { useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Divider, Stack, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';

import TextInput from 'components/Common/TextInput';
import ChangePhoto from 'pages/Account/ChangePhoto';
import Button from 'components/Common/Button';
import { createAnnouncementGroup, fetchAnnouncementGroups } from 'redux/slices/announcements/announcementGroupSlice';
import ErrorMessage from 'components/Common/ErrorMessage';
import Routes from 'constants/routes';
import InfoModal from 'components/Common/InfoModal';
import CardWrapper from 'components/Common/CardWrapper';

const defaultValues = {
    title: '',
    contact: '',
};
const formSchema = yup
    .object({
        title: yup.string().required('Enter Group Title. ').min(3, 'Title is too short - should be 3 chars minimum.'),
        contact: yup.string().required('Enter Group Contact. ').min(3, 'Contact is too short - should be 3 chars minimum.'),
    })
    .required();

const TITLE = 'Community Group';
const DESCRIPTION =
    'To create a group to easily send announcements to a specific group of parishioners please provide details here. Once created you can invite member by accessing the group in your Announcements tab within this portal. ';

const CreateAnnouncementGroup = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [imgValue, setImgValue] = useState('');
    const [imgError, setImageError] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [createGroupId, setCreateGroupId] = useState(0);
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(formSchema),
        defaultValues,
    });

    useEffect(() => {
        imgError && toggleImageError();
    }, [imgValue]);

    const toggleImageError = () => setImageError((pre) => !pre);

    const onFormSubmit = async (formData: any) => {
        if (!imgValue) {
            return toggleImageError();
        }
        const formImage = new FormData();
        formImage.append('image', imgValue);
        try {
            setLoading(true);
            const { payload } = await dispatch(createAnnouncementGroup({ formData, formImage }));
            setLoading(false);
            if (payload?.code === 200) {
                setModalOpen(true);
                setCreateGroupId(payload?.id);
                dispatch(fetchAnnouncementGroups());
            }
        } catch (error) {
            console.log('create announcement group error');
        }
    };

    const handleGroupsList = () => {
        navigate(Routes.announcements.main, { replace: true });
    };
    const handleGroupDetail = () => {
        navigate(Routes.announcements.groupDetails.replace(':id', createGroupId?.toString()), { replace: true });
    };

    return (
        <CardWrapper>
            <form onSubmit={handleSubmit(onFormSubmit)}>
                <Container sx={{ py: '2rem' }}>
                    <Typography sx={{ fontSize: 18, mb: 2, fontWeight: 400 }} variant="h1">
                        {TITLE}
                    </Typography>
                    <Divider />
                    <Typography sx={{ mt: 2, mb: 4, fontSize: 16, fontWeight: 400 }} variant="body1">
                        {DESCRIPTION}
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', marginBottom: '2rem' }}>
                        <Controller
                            name="title"
                            control={control}
                            render={({ field }) => (
                                <TextInput
                                    {...field}
                                    icon={null}
                                    label="Title"
                                    placeholder="Type title here"
                                    error={!!errors.title}
                                    helperText={errors.title?.message}
                                    sx={{ width: { xs: '100%', sm: '70%' } }}
                                />
                            )}
                        />
                        <Controller
                            name="contact"
                            control={control}
                            render={({ field }) => (
                                <TextInput
                                    {...field}
                                    icon={null}
                                    label="Contact"
                                    placeholder="Type contact information here"
                                    error={!!errors.contact}
                                    helperText={errors.contact?.message}
                                    sx={{ width: { xs: '100%', sm: '70%' }, my: 4 }}
                                />
                            )}
                        />
                    </div>

                    {/* Component Which Has The Option To Upload/Select Images */}
                    <ChangePhoto imgValue={imgValue} setImgValue={setImgValue} />
                    {imgError ? <ErrorMessage message="Image is required." /> : null}
                    <Stack alignItems="center" mt={10}>
                        <Button loading={loading} title="Create" type="submit" sx={{ width: { xs: '100%', sm: '70%', md: '30%' } }} />
                    </Stack>
                </Container>
            </form>

            <InfoModal
                description="Where do you want to navigate?"
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title="Create Announcement Group"
                renderActions={() => {
                    return (
                        <Stack direction={'row'} justifyContent={'space-around'}>
                            <Button onClick={handleGroupsList} title="Groups List" />
                            <Button onClick={handleGroupDetail} title="Group Detail" />
                        </Stack>
                    );
                }}
            />
        </CardWrapper>
    );
};

export default CreateAnnouncementGroup;
